import { useTranslation } from 'next-i18next'

import { validation } from 'src/helpers'
import * as yup from 'yup'

yup.addMethod<yup.StringSchema>(yup.string, 'mobilePhoneNumber', validation.mobilePhoneValidation)

export const useMobilePhoneValidation = (label?: string) => {
  const { t } = useTranslation()

  return {
    [label || 'mobilePhone']: yup
      .string()
      .mobilePhoneNumber(t('b2c.validation.invalidPhone'))
      .required(t('b2c.validation.required')),
  }
}

export const usePasswordValidation = () => {
  const { t } = useTranslation()

  return {
    password: yup
      .string()
      .required(t('b2c.validation.required'))
      .min(8, t('b2c.validation.password.minEight'))
      .max(32, t('b2c.validation.password.maxThirtyTwo'))
      .matches(/\d/, t('b2c.validation.password.number'))
      .matches(/[A-Z]/, t('b2c.validation.password.letter'))
      .matches(/[a-z]/, t('b2c.validation.password.lowerLetter'))
      .matches(/[\s\\"$%&'().+\-/:;<>=[\]^_`{}|~*!@#?]/, t('b2c.validation.password.specialChar')),
  }
}

export const useConsentValidation = () => {
  const { t } = useTranslation()

  return {
    termsOfServicePatientAccountConsent: yup
      .bool()
      .required(t('b2c.validation.checked'))
      .oneOf([true], t('b2c.validation.checked')),
    patientInformationConsent: yup
      .bool()
      .required(t('b2c.validation.checked'))
      .oneOf([true], t('b2c.validation.checked')),
  }
}

export const useRegistrationFormValidation = () => {
  const { t } = useTranslation()

  return yup.object().shape({
    email: yup.string().email(t('b2c.validation.invalid')).required(t('b2c.validation.required')),
  })
}
